// extracted by mini-css-extract-plugin
export var addressFields = "_gm-0";
export var animationContainer = "_gm-1";
export var footer = "_gm-2";
export var lineItems = "_gm-3";
export var modalContent = "_gm-4";
export var orderName = "_gm-5";
export var strong = "_gm-6";
export var warning = "_gm-7";